import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import './assets/el-message-fix.css' // 导入专用的ElMessage样式修复文件
import App from './App.vue';
import router from './router';
import { pinia } from './store';
import axios from 'axios';
// 导入ECharts
import * as echarts from 'echarts';

// 配置Axios - 与request.js保持一致，使用代理模式
axios.defaults.baseURL = '/api';
axios.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    // 直接使用token，不添加Bearer前缀，与request.js和后端格式保持一致
    config.headers.Authorization = token;
  }
  return config;
});

// 创建应用实例
const app = createApp(App);

// 使用插件 - 使用导入的pinia实例
app.use(pinia);
app.use(router);
app.use(ElementPlus);
app.config.globalProperties.$axios = axios;

// 注册ECharts为全局属性
app.config.globalProperties.$echarts = echarts;

// 在挂载应用前添加
app.config.productionTip = false;
app.config.devtools = false; // 禁用开发工具

// 添加全局错误处理
app.config.errorHandler = (err, instance, info) => {
  console.error('全局错误捕获:', err, info);
  // 可以添加更多的错误处理逻辑，如上报到监控系统
}

// 挂载应用
app.mount('#app');